import { singleUploadService } from 'api/singleUpload';
import {
  CASCADE_DROPDOWN_OPTIONS_SUCCESS,
  GET_CASCADE_DROPDOWN_VALUES_FAILURE,
  GET_CASCADE_DROPDOWN_VALUES_REQUEST,
  GET_CASCADE_DROPDOWN_VALUES_SUCCESS,
  GET_TARGETSITE_ERP_MAPPING_FAILURE,
  GET_TARGETSITE_ERP_MAPPING_REQUEST,
  GET_TARGETSITE_ERP_MAPPING_SUCCESS
} from 'constants/actionTypes';
import { TFS_ERP_TARGET_SITE_LU } from 'constants/constants';

export const targetsiteErp = {
  targetsiteErpMappings,
  fetchCascasdeDropdownValues,
  cascadeDropdownOptions
};

function targetsiteErpMappings() {
  return async (dispatch: any) => {
    dispatch(request(GET_TARGETSITE_ERP_MAPPING_REQUEST));
    singleUploadService.fetchDropdownValues(TFS_ERP_TARGET_SITE_LU)
      .then((resp: any) => {
        return resp.json();
      })
      .then((data: any) => {
        if (data?.error || data?.message) {
          dispatch(
            failure(
              GET_TARGETSITE_ERP_MAPPING_FAILURE,
              data?.message || 'Error fetching target site ERP mappings'
            )
          );
        } else {
          dispatch(success(GET_TARGETSITE_ERP_MAPPING_SUCCESS, data));
        }
      })
      .catch((error: any) => {
        dispatch(failure(GET_TARGETSITE_ERP_MAPPING_FAILURE, error));
      });
  };
}

function request(type: string) {
  return { type: type };
}

function success(type: string, data: any) {
  return { type, payload: { data: data } };
}

function failure(type: string, message: string) {
  return { type, payload: { message } };
}

function fetchCascasdeDropdownValues(casecadeTableId: string) {
  return async (dispatch: any) => {
    dispatch({type: GET_CASCADE_DROPDOWN_VALUES_REQUEST});
    singleUploadService.fetchDropdownValues(casecadeTableId)
      .then((resp: any) => {
        return resp.json();
      })
      .then((data: any) => {
        if (data?.error || data?.message) {
          const dataValue = {id: casecadeTableId, data: data?.message || 'Error fetching target site ERP mappings'};
          
          dispatch({
            type: GET_CASCADE_DROPDOWN_VALUES_FAILURE,
            payload: {
              message: dataValue
            }
          });
        } else {
          const dataValue = {id: casecadeTableId, data: data};
          dispatch({
            type: GET_CASCADE_DROPDOWN_VALUES_SUCCESS,
            payload: dataValue
          });
        }
      })
      .catch((error: any) => {
        const dataValue = {id: casecadeTableId, data: error || 'Error fetching target site ERP mappings'};
        dispatch({
          type: GET_CASCADE_DROPDOWN_VALUES_FAILURE,
          payload: {
            message: dataValue
          }
        });
      });
  };
}

function cascadeDropdownOptions(casecadeTableId: string, fieldId: string, options: any) {
  return async (dispatch: any) => {
    const dataValue = {id: fieldId, options: options};

    dispatch({
      type: CASCADE_DROPDOWN_OPTIONS_SUCCESS,
      payload: dataValue
    });
    
  };
}